module.exports = __webpack_public_path__ + "img/Peltast64_ua.605c6b56.webp";